var React = require('react');

function PlusAddLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0c.576 0 1.044.467 1.044 1.043v45.913a1.044 1.044 0 01-2.088 0V1.044C22.956.467 23.424 0 24 0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 24c0-.576.467-1.044 1.043-1.044h45.913a1.044 1.044 0 010 2.088H1.044A1.043 1.043 0 010 24z","key":1})]);
}

PlusAddLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = PlusAddLight;

PlusAddLight.default = PlusAddLight;
